import { useMemo } from 'react';

import { CollapsibleList } from '~/eds/src/components/CollapsibleList/CollapsibleList';
import { Layout } from '~/eds/src/components/Layout/Layout';

import { Citation as CitationType, Message } from '../../../types/chat';
import { Citation } from './Citation';

interface Props {
  message: Message;
  onSelectCitation: (citation: CitationType) => void;
}
export const Citations = ({ message, onSelectCitation }: Props) => {
  const { citations = [] } = message;

  const isHorizontal = useMemo(() => {
    return (
      citations.some((citation) => citation.entity?.type === 'ticket') ||
      citations.every((citation) => !citation.entity)
    );
  }, [citations]);

  const items = useMemo(() => {
    return citations.map((citation, index) => {
      return {
        text: `${index + 1}`,
        level: 'secondary' as const,
        citation,
        onClick: () => onSelectCitation(citation),
      };
    });
  }, [citations]);

  if (isHorizontal) {
    return (
      <Layout
        align="center"
        wrap={true}
        styles={{ ...styles.horizontalCitationContainer }}
      >
        {items.map((item, index) => (
          <Citation
            orientation="horizontal"
            citation={item.citation}
            onClick={onSelectCitation}
            text={`${index + 1}`}
          />
        ))}
      </Layout>
    );
  }
  return (
    <CollapsibleList
      name="sources_list"
      limit={3}
      items={items}
      renderItem={(item) => (
        <Citation
          text={item.text}
          citation={item.citation}
          onClick={onSelectCitation}
        />
      )}
      serializeItem={(item) => `Source ${item.text}`}
    />
  );
};

const styles = {
  horizontalCitationContainer: {
    gap: 2,
  },
};
